module.exports = __webpack_public_path__ + "img/feature-healthcare-zones.d6af9703.webp";